export const algoliaViewHit = (index, queryID, hits, startPosition) => {
    const objectIDs = [];
    const firstThreeProductID = [];
    const hitsWithPosition = [];
    for (let i = 0; i < hits.length; i++) {
        const hit = hits[i];
        objectIDs.push(hit.objectID);
        if (i < 3) {
            firstThreeProductID.push(hit.shopify_id);
        }
        hit.position = startPosition + i;
        hitsWithPosition.push(hit);
    }
    if (objectIDs.length > 0) {
        window.dataLayer.push({
            event: 'alg_view_hit',
            algolia_view: {
                index,
                queryID,
                objectIDs,
                firstThreeProductID
            },
            algolia_hits: hitsWithPosition
        });
    }
};
